import React, { useId } from 'react'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'

import AdCardListItem from '../../../../../features/components/AdCardListItem'
import SkeletonInternalAdActionButtons from '../../../../AdApprovals/AdsSection/InternalAdActionButtons/Skeleton'

import useStyles from './styles'

function SkeletonAdsGalleryItem({ photo, wrapperStyle, showDetails = true, showInternalAdActionButtonsSkeleton }) {
  const classes = useStyles()

  const keyId = useId()

  // Fallback if wrapperStyle is not provided (should be provided by RPA v3)
  const outerStyle = wrapperStyle || {
    position: 'relative',
    width: '100%'
  }

  return (
    <div style={outerStyle} key={keyId}>
      <AdCardListItem className={classes.skeletonAdCardListItem}>
        <div style={{ height: '100%' }}>
          <Skeleton style={{ height: photo?.height }} />
        </div>
        {showDetails && (
          <div className={classes.adDetails}>
            <div className={classes.adDetailsLeftColumn}>
              <h4 className={classes.adName} style={{ width: '85%' }}>
                <Skeleton />
              </h4>
              <div style={{ width: 65 }}>
                <Skeleton />
              </div>
            </div>
          </div>
        )}
        {showInternalAdActionButtonsSkeleton && (
          <SkeletonInternalAdActionButtons className={classes.internalAdActionButtons} />
        )}
      </AdCardListItem>
    </div>
  )
}

SkeletonAdsGalleryItem.propTypes = {
  showStatusChipSkeleton: PropTypes.bool,
  showInternalAdActionButtonsSkeleton: PropTypes.bool
}

export default SkeletonAdsGalleryItem
